import { ChatComposer } from '@wundo/ui';
import type { InsightChatState } from '@wundo/shared/insightChat.ts';

/** Why the composer is closed for good, said where the composer would be. */
const BLOCKED_NOTICE: Partial<Record<InsightChatState, string>> = {
  budget_reached: 'This run has used its budget. Start a new run to continue.',
  conversation_full: 'This conversation is full. Start a new run to continue.',
  unavailable: "This run's conversation is no longer available.",
};

export interface RunComposerProps {
  placeholder: string;
  chatState: InsightChatState;
  /** A question is on its way. */
  sending: boolean;
  /** Why the last question was not taken, if it was not. */
  error: string | null;
  onSend: (text: string) => void;
}

/**
 * Where a question to the analyst is written, under the run's chat. Held while
 * the analyst works — one question at a time — and closed,
 * with the reason beside it, once the run's budget or conversation is spent.
 */
export function RunComposer({
  placeholder,
  chatState,
  sending,
  error,
  onSend,
}: RunComposerProps) {
  const blockedNotice = BLOCKED_NOTICE[chatState];

  return (
    <div className='flex flex-col gap-2'>
      {blockedNotice && (
        <p role='status' className='text-sm font-semibold text-ink-secondary'>
          {blockedNotice}
        </p>
      )}
      {error && (
        <p role='alert' className='text-sm text-danger'>
          {error}
        </p>
      )}
      <ChatComposer
        placeholder={placeholder}
        sendLabel='Send'
        onSend={onSend}
        disabled={chatState === 'working' || sending}
        locked={blockedNotice !== undefined}
      />
    </div>
  );
}
